import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import store from '../store'
import {getToken} from '@/utils/auth'
import router from '../router'

// 创建axios实例
const service = axios.create({
    // baseURL: process.env.API_1, // api的base_url
    timeout: 60000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
    // console.log(config.headers)
    if (sessionStorage.getItem('token')) {
        config.headers['token'] = sessionStorage.getItem('token')// 让每个请求携带自定义token 请根据实际情况自行修改


    }
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        if (response) {
            if (response.data.code == 501) {

                sessionStorage.removeItem('token');     //删除用户登录验证的key值，即token值
                Message({
                    message: response.data.msg,
                    type: 'error',
                    duration: 3 * 1000
                })
                let role = sessionStorage.getItem('role');
                if (role == null) {

                } else if (role == 'admin') {
                    sessionStorage.removeItem('role');
                    router.replace({
                        path: '/adminlogin',
                        query: {
                            redirect: router.currentRoute.fullPath
                        }
                    })
                } else {
                    sessionStorage.removeItem('role');
                    router.replace({
                        path: '/userlogin',
                        query: {
                            redirect: router.currentRoute.fullPath
                        }
                    })
                }

            }
        }
        return response;
    },
    error => {
        console.log('err' + error)// for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js